import { styled } from "@mui/material/styles";

import { Autocomplete, createFilterOptions, TextField } from "@mui/material";
import { useField, useFormikContext } from "formik";
import { useState, useEffect, FC } from "react";
import { isExists, locale, params } from "../../utils";
import { useGetListQuery } from "../../features/api/Api";
import { IOption } from "../../interfaces/Utils";
import { useSearchDebounce } from "../../hooks";

const CssTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& label.Mui-focused": {
    color: "#853EF8",
  },
  "& label.Mui-disabled": {
    color:
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.38) !important"
        : "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#853EF8",
  },
  ".MuiOutlinedInput-input.Mui-disabled": {
    textFillColor:
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.38) !important"
        : "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#e5e5e5",
    },
    "&.Mui-disabled": {
      color:
        theme.palette.mode !== "dark"
          ? "rgba(255, 255, 255, 0.38)"
          : "rgba(0, 0, 0, 0.38)",
      fieldset: {
        borderColor:
          theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.38)"
            : "rgba(0, 0, 0, 0.38)",
      },
    },
    "&:hover fieldset": {
      borderColor: "#853EF8",
    },

    "&.Mui-focused fieldset": {
      borderColor: "#853EF8",
    },
  },
}));
function setFilter(
  query: any,
  search: string,
  id: string | number | null = null
) {
  let customQuery = {};
  if (query) {
    customQuery = { ...query };
  }

  if (search) {
    customQuery = { ...customQuery, name: search };
  }

  if (id) {
    customQuery = { ...customQuery, id };
  }

  if (Object.keys(customQuery).length > 0) {
    return customQuery;
  } else {
    return {};
  }
}
interface ICustomerSuggest {
  name: string;
  label: string;
  reference: string;
  query?: any;
  optionName: string;
  placeholder?: string;
  disabled?: boolean;
  defaultValue?: { value: string | number; label: string };
  optionId?: string;
  skip?: boolean;
  secondOptionName?: string;
  localePrefix?: string;
}

const CustomerSuggest: FC<ICustomerSuggest> = (props) => {
  const {
    label,
    name,
    reference,
    query,
    skip,
    optionId,
    secondOptionName,
    optionName,
    localePrefix,
    defaultValue,
    placeholder,
    disabled,
  } = props;
  const [field, meta] = useField(name);
  const [search, setSearchQuery] = useSearchDebounce();
  const [options, setOptions] = useState<any[]>([]);
  const formik = useFormikContext();
  const [fetchParams, setFetchParams] = useState({
    resource: reference,
    params: {
      ...params,
      pagination: { pageNumber: 0, size: 5 },
      filter: setFilter(query, search, field.value),
    },
  });
  const { data: currentData, isFetching } = useGetListQuery<any>(fetchParams, {
    skip: skip,
    //  ||
    // (formik?.values?.customerKindId === customerKindEnum.indivual
    //   ? formik?.values?.name.length > 2
    //   : formik?.values?.commercialTitle.length > 2),
    refetchOnMountOrArgChange: true,
  });
  function searchQueryHandler(event: any) {
    formik.setFieldValue(name, event.target.value, false);
    if (event.target.value.length > 2) setSearchQuery(event.target.value);
  }
  useEffect(() => {
    if (isExists(currentData?.data)) {
      let records: IOption[] = [];

      currentData.data.map((item: any) =>
        records.push({
          value: optionId ? item[optionId] : item.id,
          label: secondOptionName
            ? item[optionName] + " - " + item[secondOptionName]
            : item[optionName],
        })
      );
      records = records.sort((a: IOption, b: IOption) =>
        a.label?.toLocaleLowerCase() > b.label?.toLocaleLowerCase() ? 1 : -1
      );

      records = locale(records, localePrefix);

      setOptions(records);
    }
  }, [
    currentData,
    defaultValue,
    localePrefix,
    optionId,
    optionName,
    secondOptionName,
  ]);
  useEffect(() => {
    if (search) {
      setFetchParams((prev: any) => ({
        ...prev,
        params: {
          ...prev.params,
          filter: setFilter(query, search),
        },
      }));
    }

    if (query) {
      setFetchParams((prev: any) => ({
        ...prev,
        params: {
          ...prev.params,
          filter: setFilter(query, search),
        },
      }));
    }
  }, [search, setFetchParams, query]);

  const filterOptions = createFilterOptions({
    matchFrom: "start",
    stringify: (option: any) => option.label.toLocaleLowerCase("tr-TR"),
  });

  return (
    <Autocomplete
      freeSolo
      id={field.name}
      disableClearable
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      filterOptions={filterOptions}
      loading={isFetching}
      sx={{ width: "100%" }}
      getOptionDisabled={(option) => true}
      value={field.value}
      renderInput={(params) => (
        <CssTextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            type: "search",
          }}
          error={Boolean(meta.error)}
          helperText={meta.error && meta.touched && meta.error}
          onChange={searchQueryHandler}
        />
      )}
    />
  );
};

export default CustomerSuggest;
